<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5"></a>
<div class="img_container">
<img alt="image" src="images/Img_5_001.jpg"/>
</div>
<h1 class="toc1">Contents</h1>
<h2 class="toc2"><a href="#/xhtml/005_Chapter_1">Timeline of Events</a></h2>
<h2 class="toc2"><a href="#/xhtml/006_Chapter_2">Prelude to the Great Patriotic War</a></h2>
<h2 class="toc2"><a href="#/xhtml/007_Chapter_3">The Red Air Force</a></h2>
<h2 class="toc2"><span href="#/xhtml/008_Chapter_4" title="Link target outside of Sample">The Luftwaffe</span></h2>
<h2 class="toc2"><span href="#/xhtml/009_Chapter_5" title="Link target outside of Sample">Operation <em class="italic">Barbarossa</em></span></h2>
<h2 class="toc2"><span href="#/xhtml/010_Chapter_6" title="Link target outside of Sample">Soviet Counteroffensives</span></h2>
<h2 class="toc2"><span href="#/xhtml/011_Chapter_7" title="Link target outside of Sample">Fall of the Fatherland</span></h2>
<h2 class="toc2"><span href="#/xhtml/012_Chapter_8" title="Link target outside of Sample">Aftermath</span></h2>
<h2 class="toc2"><span href="#/xhtml/013_Chapter_9" title="Link target outside of Sample">Further Reading</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3ab18539